import { Box, Grid } from "@mui/material";
import React from "react";
import CoachSideBar from "../components/Coach/Profile/CoachSideBar";
import EmployerSidebar from "../components/Employer/EmployerSidebar";
import CandidateSideBar from "../components/Candidate/Profile/CandidateSideBar";

const UserLayout = ({ userRole, children }) => {
    return (
        <>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={2.5}>
                        {
                            userRole == "coach"
                                ?
                                <Box sx={{mt:6}}>
                                    <CoachSideBar />
                                </Box>
                                :
                                userRole == "employer"
                                    ?
                                    <Box sx={{mt:6}}>
                                        <EmployerSidebar />
                                    </Box>
                                    :
                                    <Box sx={{mt:6}}>
                                        <CandidateSideBar />
                                    </Box>
                        }
                    </Grid>
                    <Grid item xs={12} md={9.5}>
                        {children}
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default UserLayout;